import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigate} from "react-router-dom";
import Navbar from './components/navbar'; 
import Footer from './components/footer';
import LandingPage from './pages/landingpage';
import MemebershipDetails from "./pages/MembershipDetails";
import MembershipList from "./pages/MembershipList";
import Notification from "./pages/Notifications";
import Matchingprofile from "./pages/MatchingProfiles";
import Selectedprofile from "./pages/SelectedProfiles";
import Allprofile from "./pages/AllProfiles";
import Phnnumberpage from "./pages/login";
import Otppage from "./pages/otpvari";
import Registered from "./pages/log2";
import Pending from "./pages/pending";
import MyProfile from "./pages/MyProfile";
import Newacc from "./pages/newac";
import Newotp from "./pages/Newotp";
import Profilepreview from './pages/ProfilePreviewPage';
import Signinform from "./pages/signinForm";
import MatchingProfileInfo from "./pages/matchingprofileinfo";
import SelectedProfileInfo from "./pages/selectedprofileinfo";
import AllProfileInfo from "./pages/allprofileinfo";
import Rejected from "./pages/reject";
import Notfound from "./pages/notfound";
import Forgotpassword from "./pages/forgot";
import Loginsuccessfull from "./pages/success";
import Passwordreset from "./pages/reset";
import Resetsuccessfull from "./pages/resetsuccess";
import PhoneNumberVerification from "./pages/preregister";
import OtpToRegister from "./pages/otpregister";
import './App.css'; 
import ProtectedRoute from "./components/ProtectedRoute";
import { useEffect } from "react";






function App() {
  /*
  useEffect(() => {
    const disableRightClick = (e) => {
      e.preventDefault();
    };

    document.addEventListener("contextmenu", disableRightClick);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
    };
  }, []);
  */
  return (
    <Router>
      <Navbar />

      <Routes>

        {/* Redirect root to login */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* Public Routes */}
        <Route path="/login" element={<Phnnumberpage />} />
        <Route path="/otp-page" element={<Otppage />} />
        <Route path="/registered" element={<Registered />} />
        <Route path="/pending" element={<Pending />} />
        <Route path="/newacc" element={<Newacc />} />
        <Route path="/newotp" element={<Newotp />} />
        <Route path="/forgotpassword" element={<Forgotpassword />} />
        <Route path="/loginsuccessfull" element={<Loginsuccessfull />} />
        <Route path="/passwordreset" element={<Passwordreset />} />
        <Route path="/resetsuccessfull" element={<Resetsuccessfull />} />
        <Route path="/registerphone" element={<PhoneNumberVerification />} />
        <Route path="/otpregister" element={<OtpToRegister />} />

        {/* PROTECTED ROUTES */}
        <Route
          path="/landingpage"
          element={
            <ProtectedRoute>
              <LandingPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/membership-list"
          element={
            <ProtectedRoute>
              <MembershipList />
            </ProtectedRoute>
          }
        />

        <Route
          path="/membership-details"
          element={
            <ProtectedRoute>
              <MemebershipDetails />
            </ProtectedRoute>
          }
        />

        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <Notification />
            </ProtectedRoute>
          }
        />

        <Route
          path="/matching-profiles"
          element={
            <ProtectedRoute>
              <Matchingprofile />
            </ProtectedRoute>
          }
        />

        <Route
          path="/selected-profiles"
          element={
            <ProtectedRoute>
              <Selectedprofile />
            </ProtectedRoute>
          }
        />

        <Route
          path="/all-profiles"
          element={
            <ProtectedRoute>
              <Allprofile />
            </ProtectedRoute>
          }
        />

        <Route
          path="/my-profile"
          element={
            <ProtectedRoute>
              <MyProfile />
            </ProtectedRoute>
          }
        />

        <Route
          path="/siginpreview"
          element={
            <ProtectedRoute>
              <Profilepreview />
            </ProtectedRoute>
          }
        />

        <Route
          path="/matching-profile-info"
          element={
            <ProtectedRoute>
              <MatchingProfileInfo />
            </ProtectedRoute>
          }
        />

        <Route
          path="/selected-profile-info"
          element={
            <ProtectedRoute>
              <SelectedProfileInfo />
            </ProtectedRoute>
          }
        />

        <Route
          path="/all-profile-info"
          element={
            <ProtectedRoute>
              <AllProfileInfo />
            </ProtectedRoute>
          }
        />

        <Route path="/rejected" element={<Rejected />} />
        <Route path="/usernotfound" element={<Notfound />} />

      </Routes>

      <Footer />
    </Router>
  );
}


export default App;
